// Scorecard Widget Configuration
// A single 5-point dropdown scoring widget (-- to ++)

export type ScoreValue = '--' | '-' | '=' | '+' | '++';

export const SCORE_OPTIONS: { value: ScoreValue; label: string }[] = [
  { value: '--', label: '--' },
  { value: '-', label: '-' },
  { value: '=', label: '=' },
  { value: '+', label: '+' },
  { value: '++', label: '++' },
];

// Intensity tracks extremity: the strongest grades (-- / ++) are the DARKEST,
// mild grades (- / +) lighter. (Previously inverted — -- read lighter than -.)
export const SCORE_COLORS: Record<ScoreValue, { bg: string; text: string; border: string }> = {
  '--': { bg: 'bg-danger-600', text: 'text-white', border: 'border-danger-600' },
  '-':  { bg: 'bg-danger-400', text: 'text-white', border: 'border-danger-400' },
  '=':  { bg: 'bg-neutral-500', text: 'text-white', border: 'border-neutral-500' },
  '+':  { bg: 'bg-success-400', text: 'text-white', border: 'border-success-400' },
  '++': { bg: 'bg-success-600', text: 'text-white', border: 'border-success-600' },
};

// Human-readable meaning per grade — used for chip tooltips / a legend so the
// --..++ scale isn't opaque to a manager scanning the grid.
export const SCORE_LABELS: Record<ScoreValue, string> = {
  '--': 'Very bearish',
  '-':  'Bearish',
  '=':  'Neutral',
  '+':  'Bullish',
  '++': 'Very bullish',
};

// Available layout variants for the scorecard widget. Same data, different
// presentation. Selected per-instance from the dashboard builder.
export type ScorecardLayout = 'carousel' | 'segmented';

export const SCORECARD_LAYOUTS: { value: ScorecardLayout; label: string }[] = [
  { value: 'carousel', label: 'Carousel' },
  { value: 'segmented', label: 'Segmented' },
];

export interface ScorecardWidgetConfig {
  showLabels?: boolean;
  layout?: ScorecardLayout;
}

export interface ScorecardWidgetInstanceConfig extends ScorecardWidgetConfig {
  dataKey: string;
}

// Dashboard data for a scorecard widget — just a single score
export interface ScorecardDataContent {
  score?: ScoreValue;
}
